import React from 'react';
import Select from 'react-select';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import './css/custom.css';
import './css/ExpandTable.css';
import xml2js from "xml2js";
import BootstrapTable from 'react-bootstrap-table-next';
import { getWeeksDiff, getYearsDiff, getSemestralDiff } from './functions/ExpandTableFunctions';
import {
    NavItem, NavLink, Nav, TabContent, TabPane, Input, UncontrolledAlert,
    Row, Col, Card, Button, Form, Spinner, FormGroup, Label, Container
} from 'reactstrap';
import { withRouter } from "react-router";
import FormularioAct from './FormularioAct';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import Image from 'react-bootstrap/Image';
import { AppContext } from './../AppContext';
import url from './variables/url.js';
const local = url.localBack;

function importAll(r) {
  let images = {};
  r.keys().forEach((item, index) => { images[item.replace('./', '')] = r(item); });
  return images
}

const images = importAll(require.context('./icons', false, /\.(png|jpe?g|svg)$/));

const MySwal = withReactContent(Swal)
// { "id": 2, "name": "alola3", "price": "4" }];

const currentDate = new Date();

class AgregarActividad extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
        idpersona: 0,
        nombreProfesor: '',
        cedula: '',
        multiTermino: "",
        terminos: [],
        optsTerminos: [{
            "idPeriodo": 584,
            "nombre": "PAE 2022",
            "fechaInicio": "2022-03-14",
            "fechaFin": "2022-05-06"
            },
            {
                "idPeriodo": 585,
                "nombre": "PAO 2022-1",
                "fechaInicio": "2022-05-09",
                "fechaFin": "2022-09-23"
            },
            {
                "idPeriodo": 586,
                "nombre": "PAO 2022-2",
                "fechaInicio": "2022-09-26",
                "fechaFin": "2023-02-17"
            }],
        dataForm: [],
        options: [],
        optionSelected: {},
        idOption: 0,
        idambito: 'R',
        filtroAmbito: 'D',
        periodo: 0,
        nivel: "1",
        observacion: "",
        descripcion: "",
        PAE: false,
        PAO1: false,
        PAO2: true,
        formState: 'N',
        alertaPeriodo: true,
        alertaObservacion: true,
        alertaDescripcion: true,
        alertaActividad: true,
        alertNivel: true,
        messagePeriodo: '',
        messageObservacion: '',
        messageDescripcion: '',
        messageActividad: '',
        //Actividad Horas 
        EditHoras: 'N',
        tipoCalculo: 'S',
        nhorasSem: 0,
        duracionTipo: 0,
        fechaInicio: '',
        fechaFin: '',
        fechaMin: '',
        fechaMax: '',
        max: 0,
        totalhoras: 0,        
        fechaInicioSub: "",
        fechaFinSub: ""
    };    

      this.handleMultipleChange = this.handleMultipleChange.bind(this);
      this.handleAmbitoChange = this.handleAmbitoChange.bind(this);
      this.handleChangeCheck = this.handleChangeCheck.bind(this);
      this.handleDuracionChange = this.handleDuracionChange.bind(this);
      this.handleFechaChange = this.handleFechaChange.bind(this);
      this.handleInputChange = this.handleInputChange.bind(this);
      this.handleSave = this.handleSave.bind(this);
      this.handleSearch = this.handleSearch.bind(this);
      this.handleDescription = this.handleDescription.bind(this);

      fetch(local + 'Validacion/Getapplaw', {
          method: 'GET'
      }).then(response => response.json())
          .then(data => {
              //console.log("leyes", data)
              //console.log("leyesInicio", data.fecha_inicio_sub)
              //console.log("leyesFin", data.fecha_fin_sub)
              this.setState({ fechaInicioSub: data.fecha_inicio_sub, fechaFinSub: data.fecha_fin_sub })
          }).catch(function F(error) {
              console.log(error);
          });

    fetch(local + 'Validacion/GetDataForm', {
      method: 'GET'
    }).then(response => response.json())
      .then(data => {
          /*console.log("DATAFORRRRRM", data)*/
          let lista = data["terminos"].grado;
          /*console.log(lista);*/
          let primero = lista[0]
          let ultimo = lista[lista.length - 1]
          this.setState({ dataForm: data, fechaInicio: primero.fechaInicio, fechaFin: ultimo.fechaFin, fechaMin: primero.fechaInicio, fechaMax: ultimo.fechaFin })
      }).catch(function F(error) {
        console.log(error);
      });

      fetch(local + 'Validacion/GetDataTipoActividad', {
          method: 'GET'
      }).then(response => response.json())
          .then(data => {
              /*console.log("tipos", data)*/
              this.setState({ options: data })
          }).catch(function F(error) {
              console.log(error);
          });

      fetch(local + 'Validacion/GetInfoAgregarActividad/' + this.props.match.params.id, {
          method: 'GET'
      }).then(response => response.json())
          .then(data => {
             /* console.log("Info", data)*/
              this.setState({ idpersona: data.idPersona, nombreProfesor: data.nombreProfesor, cedula: data.cedula })
          }).catch(function F(error) {
              console.log(error);
          });
  }  

    changeFormat(fecha) {
        const date = fecha.split('T');
        //eXAMPLE
        //"2022-09-30"
        //"07:59:59"
        const [year, month, day] = date[0].split('-');
        const [hours, minutes, seconds] = date[1].split(':');

        var resp = new Date(+year, month - 1, +day, +hours, +minutes, +seconds);
        return resp;
    }

    calculosHorasSem(tipoCalculo, duracionTipo, inicio, fin) {
        let semanas = 0;
        if (tipoCalculo == 'S') {
            //console.log("Semanal");
            semanas = getWeeksDiff(Date.parse(inicio), Date.parse(fin));
        } else if (tipoCalculo == 'A') {
            //console.log("Anual");
            semanas = getYearsDiff(Date.parse(inicio), Date.parse(fin));
        } else {
            //console.log("Semestral");
            semanas = getSemestralDiff(Date.parse(inicio), Date.parse(fin));
        }
        //console.log(semanas);
        this.setState({ nhorasSem: semanas * duracionTipo });
    }

    handleMultipleChange = (selectedChange) => {
        
        this.calculosHorasSem(selectedChange.tipoCalculo, selectedChange.duraciontipo, this.state.fechaInicio, this.state.fechaFin)
        this.setState({
            optionSelected: selectedChange,
            tipoCalculo: selectedChange.tipoCalculo,
            EditHoras: selectedChange.tieneLimite,
            idOption: selectedChange.value,
            duracionTipo: selectedChange.duraciontipo,
            max: selectedChange.duraciontipo
        }, () => {
            //console.log('Seleccionado Multiple: ', this.state.optionSelected)
            console.log('');
        })
    }

    handleDuracionChange(event) {
        const target = event.target;
        const name = target.name;
        let value = target.type === 'checkbox' ? target.checked : target.value;        
        let min = 1;
        let max = this.state.max;
        if (value >= min && value <= max) {
            this.calculosHorasSem(this.state.tipoCalculo, value, this.state.fechaInicio, this.state.fechaFin);
            this.setState({ duracionTipo: value });
        }
    };

    changeFormat(fecha) {
        const date = fecha.split('T');
        //eXAMPLE
        //"2022-09-30"
        //"07:59:59"
        const [year, month, day] = date[0].split('-');
        const [hours, minutes, seconds] = date[1].split(':');

        var resp = new Date(+year, month - 1, +day, +hours, +minutes, +seconds);
        return resp;
    };

    handleFechaChange(event) {
        const target = event.target;
        const name = target.name;
        let value = target.type === 'checkbox' ? target.checked : target.value;
            if (name == 'fechaInicio') {
                this.calculosHorasSem(this.state.tipoCalculo, this.state.duracionTipo, value, this.state.fechaFin);
                this.setState({ fechaInicio: value });
            } else {
                this.calculosHorasSem(this.state.tipoCalculo, this.state.duracionTipo, this.state.fechaInicio, value);
                this.setState({ fechaFin: value });
            }
                
    };

    handleAmbitoChange(event){
        var cod = event.target.value;
        var fil = cod == 'R' || cod == 'P' ? 'D' : cod == 'G' ? 'A' : cod
        this.setState({ idambito: cod, filtroAmbito: fil, optionSelected: null });
        //console.log('filtro', fil);
        //console.log('codigo', cod);
    };

    handleInputChange(event) {
        var cod = event.target.value;
        var ambito = cod == '1' ? 'R' : 'P';        
        this.setState({ nivel: cod, idambito: ambito, filtroAmbito: 'D'});
    };

    handleSearch(event) {
        this.setState({ observacion: event.target.value });
        //console.log(this.state.observacion);
    };

    handleDescription(event) {
        this.setState({ descripcion: event.target.value });
        //console.log(this.state.descripcion);
    };

    handleChangeCheck(periodo) {
        let nvalue1 = this.state.PAO1;
        let nvalue2 = this.state.PAO2;
        let nvalue3 = this.state.PAE;
        if (periodo == 'PAO-1') {
            if (nvalue1) {
                nvalue1 = false;
            } else {
                nvalue1 = true;
            }
        }
        if (periodo == 'PAO-2') {
            if (nvalue2) {
                nvalue2 = false;
            } else {
                nvalue2 = true;
            }            
        }        
        if (periodo == 'PAE') {
            if (nvalue3) {
                nvalue3 = false;
            } else {
                nvalue3 = true;
            }
        }
        //console.log('Check', nvalue2);
        this.setState({ PAO2: nvalue2, PAO1: nvalue1, PAE: nvalue3 });
    };

    mensajeObservacion(texto) {
        this.setState({ alertaObservacion: false, messageObservacion: texto })
    }

    mensajeDescripcion(texto) {
        this.setState({ alertaDescripcion: false, messageDescripcion: texto })
    }

    mensajePeriodo(texto) {
        this.setState({ alertaPeriodo: false, messagePeriodo: texto })
    }

    mensajeActividad(texto) {
        this.setState({ alertaActidad: false, messageActividad: texto })
    }

    handleSave = (event) => {
        event.preventDefault();
        let problemas = 0;
        this.setState({ formState: 'L' });
        let dto = {};
        dto["Ambito"] = this.state.idambito;
        dto["idpersona"] = this.props.match.params.id;
        dto["idTipoActividad"] = this.state.optionSelected.value;
        dto["observacion"] = this.state.observacion;
        dto["descripcion"] = this.state.descripcion;
        dto["pae"] = this.state.PAE;
        dto["pao1"] = this.state.PAO1;
        dto["pao2"] = this.state.PAO2;
        dto["fechaInicio"] = this.state.fechaInicio;
        dto["fechaFin"] = this.state.fechaFin;
        dto["nivel"] = this.state.nivel;
        dto["horasSem"] = this.state.duracionTipo;
        dto["horas"] = this.state.nhorasSem;
        //console.log(dto);
        if (!(this.state.PAE || this.state.PAO1 || this.state.PAO2)) {
            problemas++
            this.mensajePeriodo('Debe seleccionar al menos un periodo.')
        } else {
            this.setState({ alertaPeriodo: true });
        }
        if (this.state.observacion == "") {
            problemas++
            this.mensajeObservacion("No puede enviar la observacion vac�a.")
        } else {
            this.setState({ alertaObservacion: true });
        }
        if (this.state.descripcion == "") {
            problemas++
            this.mensajeDescripcion("No puede enviar la descripci�n vac�a.")
        } else {
            this.setState({ alertaDescripcion: true });
        }
        if (this.state.optionSelected.value == 0) {
            problemas++
            this.mensajeActividad('Debe seleccionar una actividad.')
        } else {
            this.setState({ alertaActidad: true });
        }
        const data = JSON.stringify(dto);
        /*console.log(data);*/
        if (problemas == 0) {
            fetch(local + 'Validacion/PostAgregarActividad', {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: data,
            }).then((response) => {
                if (response.ok) {
                    MySwal.fire({
                        icon: 'success',
                        title: 'Solicitud ingresada',
                        text: 'Datos guardados exitosamente!',
                        confirmButtonText: 'Listo',                        
                    })
                    window.location.replace("/profesor/" + this.props.match.params.id);
                } else {
                    MySwal.fire(
                        'Error',
                        'Error',
                        'error'
                    )
                }
            })
        }
        this.setState({ formState: 'N', alerta: false });
    }

    cancelar() {
        window.location.replace("/profesor/"+this.props.match.params.id);
    }

    render() {
        const { EditHoras, fechaInicioSub, fechaFinSub } = this.state;
        const optGrado = this.state.optsTerminos.map(ej =>
            ({ value: ej.idPeriodo, label: ej.nombre })
        );
        let optChosed = optGrado.filter((x) => { return this.state.terminos.includes(x.value.toString()) })
    return (
        <>
            {fechaInicioSub != "" && fechaFinSub != "" ?
                <Container fluid>
                <Form onSubmit={this.handleSave}>
                    <Row>
                        <Col md={2}>
                            <Image src={"https://talentohumano.espol.edu.ec/imgEmpleado/" + this.state.cedula + ".jpg"}
                                onError={(e) => (e.target.onerror = null, e.target.src = images['user2.png'].default)}
                                style={{ width: 60, height: 60, borderRadius: '50%', overflow: 'hidden', borderWidth: 3, borderColor: 'red', }} />
                        </Col>
                        <Col md={4} >
                            <FormGroup >
                                <Label for="profesor">
                                    Profesor
                                </Label>
                                <Input
                                    id={"profesor"}
                                    name="profesor"
                                    readOnly
                                    defaultValue={this.state.nombreProfesor}
                                />
                            </FormGroup>
                        </Col>
                        <Col md={4} >
                            <FormGroup >
                                <Label for="nivel">
                                    Nivel
                                </Label>
                                <Input
                                    id={"nivel"}
                                    name="nivel"
                                    type="select"
                                    onChange={this.handleInputChange}
                                    value={this.state.nivel}
                                    disabled={this.props.banderaDecano}
                                >
                                    <option key="1" value="1" >Grado</option>
                                    <option key="2" value="2" >Postgrado</option>
                                    <option hidden key="3" value="3" >Admisiones</option>
                                </Input>
                                <Label hidden={this.state.alertNivel} style={{ color: 'red' }}>
                                    *Por favor seleccione un nivel.
                                </Label>
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col sm="12" md="8">
                            <FormGroup>
                                <Label for="exampleSelect">Ambito*</Label>
                                <Input type="select" name="Ambito" id="Ambito" onChange={this.handleAmbitoChange} value={this.state.idambito}>
                                    <option hidden={this.state.nivel == 2} key="D" value="R">Docencia de Grado</option>
                                    <option hidden={this.state.nivel == 1} key="D" value="P">Docencia de Postgrado</option>
                                    <option hidden key="A" value="A">Admisiones</option>
                                    <option hidden={this.state.nivel == 2} key="I" value="I">Investigaci&oacute;n</option>
                                    <option hidden={this.state.nivel == 2} key="V" value="V">Vinculaci&oacute;n</option>
                                    <option key="A" value="G">Gesti&oacute;n Ac&aacute;demica</option>
                                </Input>
                            </FormGroup>
                        </Col>
                        <Col sm="12" md="4">
                            <FormGroup>
                                <Label for="exampleSelect">Periodo*</Label>
                                    <br />
                                {/*<div>*/}
                                {/*    <Input class="PAO-1" type="checkbox" checked={this.state.PAO1} id="PAO-1" name="PAO-1" value={this.state.PAO1} onClick={() => this.handleChangeCheck('PAO-1')} />*/}
                                {/*    <Label class="PAO-1" for="PAO-1" onClick={() => this.handleChangeCheck('PAO-1')}>*/}
                                {/*       &nbsp;PAO-1*/}
                                {/*    </Label>*/}
                                {/*</div>*/}
                                <div >
                                    <Input class="PAO-2" type="checkbox" checked={this.state.PAO2} id="PAO-2" name="PAO-2" value={this.state.PAO2} />
                                    <Label class="PAO-2" for="PAO-2" onClick={() => this.handleChangeCheck('PAO-2')}>
                                        &nbsp;PAO-2
                                    </Label>
                                    </div>
                                    <div >
                                        <Input class="PAE" type="checkbox" checked={this.state.PAE} id="PAE" name="PAE" value={this.state.PAE} />
                                        <Label class="PAE" for="PAE" onClick={() => this.handleChangeCheck('PAE')}>
                                            &nbsp;PAE
                                        </Label>
                                    </div>
                            </FormGroup>
                            <Label hidden={this.state.alertaPeriodo} style={{ color: 'red' }}>
                                *{this.state.messagePeriodo}
                            </Label>
                        </Col>
                    </Row>
                    <Row>
                        <FormGroup>
                            <Label for="exampleSelect">Actividad*</Label>
                            <Select id="actividad"
                                options={this.state.options.filter(x => x.actividad == this.state.filtroAmbito)}
                                value={this.state.optionSelected}
                                onChange={this.handleMultipleChange}
                            />
                        </FormGroup>
                    </Row>
                    <Row  >
                        <Col md={2}  >
                            <FormGroup >
                                <Label for="typeCalculo" >
                                    Tipo Calculo
                                </Label>
                                <Input
                                    id={"typeCalculo" + this.state.idForm}
                                    name="typeCalculo"
                                    type="typeCalculo"
                                    value={this.state.tipoCalculo === 'S' ? 'Semanal' : this.state.tipoCalculo === 'A' ? 'Anual' : 'Semestral'}
                                    readOnly
                                    style={{ padding: "0.375rem 0.375rem" }}
                                />
                            </FormGroup>
                        </Col>
                        <Col md={2}  >
                            <FormGroup >
                                <Label for="duraciontipo" >
                                    N&uacute;mero Horas
                                </Label>
                                <Input
                                    className="mb-3"
                                    name='duraciontipo'
                                    id={'duraciontipo'}
                                    type='number'
                                    readOnly={EditHoras == 'N' ? true : false}
                                    value={this.state.duracionTipo}
                                    onChange={this.handleDuracionChange}
                                />
                            </FormGroup>
                        </Col>
                        <Col md={2}  >
                            <FormGroup >
                                <Label for="nhorasSem" >
                                    Total Horas
                                </Label>
                                <Input
                                    className="mb-3"
                                    name='nhorasSem'
                                    id={'nhorasSem'}
                                    type='number'
                                    readOnly
                                    value={this.state.nhorasSem}
                                    onChange={this.handleInputChange}

                                />
                            </FormGroup>
                        </Col>
                        <Col md={2} >
                            <FormGroup >
                                <Label for="fechaInicio">
                                    Fecha Ingreso
                                </Label>
                                <Input
                                    id={"fechaInicio"}
                                    name="fechaInicio"
                                    type="date"
                                    value={this.state.fechaInicio}
                                    onChange={this.handleFechaChange}
                                    style={{ padding: "0.375rem 0.375rem" }}
                                    readOnly={this.props.banderaDecano}
                                    required
                                />
                            </FormGroup>
                        </Col>
                        <Col md={2} >
                            <FormGroup >
                                <Label for="fechaFin">
                                    Fecha Fin
                                </Label>
                                <Input
                                    id={"fechaFin"}
                                    name="fechaFin"
                                    value={this.state.fechaFin}
                                    type="date"
                                    onChange={this.handleFechaChange}
                                    style={{ padding: "0.375rem 0.375rem" }}
                                    readOnly={this.props.banderaDecano}
                                    required
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Label hidden={this.state.alertaActividad} style={{ color: 'red' }}>
                        *{this.state.messageActividad}
                    </Label>
                    <div class="form-group">
                       <label for="descripcion">Descripci&oacute;n Actividad</label>
                        <textarea class="form-control" disabled={this.state.formState == 'L'} id="descripcion" rows="3"
                            onChange={this.handleDescription}></textarea>
                    </div>
                    <Label hidden={this.state.alertaDescripcion} style={{ color: 'red' }}>
                         *{this.state.messageDescripcion}
                    </Label>
                    <div class="form-group">
                        <label for="observacion">Observaci&oacute;n</label>
                        <textarea class="form-control" disabled={this.state.formState == 'L'} id="observacion" rows="3"
                            onChange={this.handleSearch}></textarea>
                    </div>
                    <Label hidden={this.state.alertaObservacion} style={{ color: 'red' }}>
                        *{this.state.messageObservacion}
                    </Label>
                    {currentDate > this.changeFormat(fechaInicioSub) && currentDate < this.changeFormat(fechaFinSub)
                        ?
                        <div className='flex-box-2'>
                            <Button type="submit" className='btn-info btn-round' >
                                Agregar
                            </Button>

                            <Button className='btn-danger btn-round' disabled={this.state.formState == 'L'} onClick={() => { this.cancelar() }}>
                                Cancelar
                            </Button>
                        </div>
                        :
                        <label>Ha finalizado la fecha de subdecano no se puede generar mas carga.</label>
                    }

                </Form>
                </Container> 
                : <Spinner animation="grow" />
            }
      </>
    );
  }
}
AgregarActividad.contextType = AppContext;
export default withRouter(AgregarActividad);